module.exports = __webpack_public_path__ + "static/media/red-navbar.6414056b.svg";